import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "ul",
  "ol",
  "li",
  "blockquote",
  "pre",
  "code",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "a",
  "hr",
  "sub",
  "sup",
  "mark",
  "span",
];

const ALLOWED_ATTR = ["href", "target", "rel", "class"];

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.hasAttribute("target")) {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}

export function richTextToPlainText(html: string): string {
  if (!html) {
    return "";
  }
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent ?? "";
}

/**
 * Whether rich-text markup holds any visible text. Markup can be structurally
 * non-empty yet render as blank — a whitespace-only paragraph, or a bare
 * `"<p></p>"` left behind by an editor or stored on an older record — so a plain
 * truthiness check on the HTML reads an empty field as filled.
 */
export function hasRichText(html?: string | null): boolean {
  return richTextToPlainText(html ?? "").trim() !== "";
}
